import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaValorPago = (): TabelaColuna => ({
  Chave: 'valorPago',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.valorPago)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Valor Pago</div>
})
